import { type EBanners } from '../../constants/banners';

export function setBannerBlockHeight(container: HTMLElement | null, bannerType: EBanners | null): void {
  if (!container || !bannerType) {
    return;
  }

  container.style.height = '0';
}
